/**
 * API 응답 봉투를 벗긴다. 봉투가 아니면 그대로 돌려준다.
 *
 * 백엔드가 엔드포인트를 `PetrohqApiResponse<T>`로 바꾸는 중이라 배포 순서에 따라
 * 같은 경로가 봉투일 수도, 알맹이일 수도 있다. 두 형태를 모두 받아 두면
 * web과 api를 어느 쪽 먼저 배포해도 화면이 깨지지 않는다.
 *
 * 전환이 끝나면 이 헬퍼를 지우고 `res.result`로 직접 읽는다.
 */
export function unwrap<T>(res: T | { result: T }): T {
    if (res !== null && typeof res === 'object' && 'result' in res) {
        return (res as { result: T }).result;
    }
    return res as T;
}
